var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useContext } from 'react';
import { CheckIcon, AlertTriangleIcon } from '@cvent/carina-icon';
import { LoadingIcon } from '@cvent/carina-progress-indicator';
import { ThemeContext } from '@cvent/carina-theme-provider';
import useStyle from './StepIconStyles';
import iconTypes from './StepIconTypes';
/** StepIcon */
var StepIcon = function (_a) {
    var index = _a.index, status = _a.status, _b = _a.hover, hover = _b === void 0 ? false : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.showStepNumber, showStepNumber = _d === void 0 ? false : _d;
    var theme = useContext(ThemeContext);
    var iconContent = showStepNumber ? index : null;
    switch (status) {
        case iconTypes.processing:
            iconContent = _jsx(LoadingIcon, { size: "l" }, void 0);
            break;
        case iconTypes.completed:
            iconContent = (_jsx(CheckIcon, { color: theme.backgroundColor.accent.fill.base, size: "l" }, void 0));
            break;
        case iconTypes.error:
            iconContent = (_jsx(AlertTriangleIcon, { color: theme.font.color.danger.base, size: "l" }, void 0));
            break;
        default:
    }
    var _e = useStyle({ isSelected: isSelected, status: status, hover: hover }), iconWrapper = _e.iconWrapper, main = _e.main;
    return (_jsx("div", __assign({ css: iconWrapper }, { children: _jsx("div", __assign({ css: main }, { children: iconContent }), void 0) }), void 0));
};
export { StepIcon, iconTypes };
